import { createReducer, on } from '@ngrx/store';
import * as accUsr from '../actions/usuario.actions';
import * as modelUsr from '../models/usuario.model';
import { environment } from 'src/environments/environment';
export { UsuarioState } from '../models/usuario.model';

export const usuarioInitState: modelUsr.UsuarioState = {
    usuario: null,
    menu: [],
    rutasPermitidas: [],
    catExpedientes: [],
    loaded: false,
    loading: false,
    error: null
}

const gpoAdmin = environment.idGPOAdministrador;
console.log(gpoAdmin);

const gpoProv = environment.idGPOProveedor;
console.log(gpoProv);


const gpoAdminEmpresa = sessionStorage.getItem('---') != undefined ? true : false;

const _usuarioReducer = createReducer(usuarioInitState,

    on(accUsr.solicitarDatosUsuarioAcc, (state) => ({ ...state, loading: true })),

    on(accUsr.resetDatosUsuarioAcc, (state) => ({ ...usuarioInitState  })),
    


    on(accUsr.obtenerUsuarioSuccessAcc, (state, { Usuario }) => { 
        
        let menu = [];
        
        if( Usuario.group.includes(gpoAdmin) && Usuario.idEmpresa == null ){
           menu = [...Usuario.menu,modelUsr.MENULATERAL[3], modelUsr.MENULATERAL[2], modelUsr.MENULATERAL[6], modelUsr.MENULATERAL[7]]
        }
        else if( Usuario.group.includes(gpoAdmin) && Usuario.idEmpresa ) {
            menu = [...Usuario.menu,modelUsr.MENULATERAL[3], modelUsr.MENULATERAL[2]]
        }
        else {
            menu = [...Usuario.menu,modelUsr.MENULATERAL[3], modelUsr.MENULATERAL[4]]
        }
        

        return {...state,
            loaded: true,
            loading: false,
            usuario: Usuario,
            menu: menu,
            /* menu:  [...Usuario.menu,modelUsr.MENULATERAL[3] , Usuario.group.includes(gpoAdmin) ? modelUsr.MENULATERAL[2] :[], gpoAdminEmpresa == true ? modelUsr.MENULATERAL[2] :[], Usuario.group.includes(gpoProv) ? modelUsr.MENULATERAL[4] :[],Usuario.group.includes(gpoAdmin) ? modelUsr.MENULATERAL[6] :[],Usuario.group.includes(gpoAdmin) ? modelUsr.MENULATERAL[7] :[] ] , */
            rutasPermitidas:  Usuario.modulo,
            catExpedientes: Usuario.catExpedientes }
    }),


    on(accUsr.obtenerUsuarioErrorAcc, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: false,
        error: {
            url: payload.url,
            name: payload.name,
            message: payload.message
        }
    })),

);

export function usuarioReducer(state, action) {
    return _usuarioReducer(state, action);
}